// components/AvatarUpload/index.js - Versão ajustada
import React, { useContext, useState } from 'react';
import { MdCloudUpload } from 'react-icons/md';
import { AuthContext } from '../../context/Auth/AuthContext';
import { getBackendUrl } from '../../config';

const backendUrl = getBackendUrl();

const AvatarUploader = ({ setAvatar, avatar, companyId }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const { user } = useContext(AuthContext);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    // Validar tipo de arquivo
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      alert('Formato de arquivo não suportado. Use apenas JPG, PNG, GIF ou WebP.');
      return;
    }

    // Validar tamanho (máximo 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      alert('Arquivo muito grande. Tamanho máximo: 5MB');
      return;
    }

    setSelectedFile(file);
    setAvatar(file);

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Função para determinar qual imagem exibir
  const getImageSrc = () => {
    if (previewImage) return previewImage;
    if (avatar && companyId) return `${backendUrl}/public/company${companyId}/user/${avatar}`;
    return '/nopicture.png';
  };

  return (
    <div className="flex flex-col items-center">
      <img
        alt="User Avatar"
        src={getImageSrc()}
        className="h-[120px] w-[120px] cursor-pointer rounded-full border-2 border-[#ccc] object-cover"
        onClick={() => document.getElementById('avatar-upload').click()}
        onError={(e) => {
          // Fallback para imagem padrão em caso de erro
          e.target.src = '/nopicture.png';
        }}
      />

      <input
        accept="image/*"
        type="file"
        id="avatar-upload"
        className="hidden"
        onChange={handleFileChange}
      />
      <label
        htmlFor="avatar-upload"
        className="mt-2.5 inline-flex h-10 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-solid border-[var(--primaryColor)] bg-[var(--primaryColor)] px-4 text-sm font-semibold text-white shadow-sm outline-none transition-colors hover:brightness-90"
      >
        <MdCloudUpload size={18} />
        {avatar ? 'Alterar Avatar' : 'Upload Avatar'}
      </label>
    </div>
  );
};

export default AvatarUploader;
